<template src="./PartnerListComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {usePartnerStore} from "@/stores/partner.js";
import {useAccountStore} from "@/stores/account.js";
import {AppConstant, CommonText} from "@/supports/app.constant";
import {ref, onMounted, computed, reactive, watch} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import {useRouter} from "vue-router";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import SelectCustom from "@/components/inputs/select/custom/SelectCustom.vue";
import LoadingComponent from "@/components/loading/LoadingComponent.vue";
import ModalProductImportComponent from "@/components/modals/modal-product-import/ModalProductImportComponent.vue";
import ModalProductExportComponent from "@/components/modals/modal-export/ModalExportComponent.vue";
import ModalExportComponent from "@/components/modals/modal-export/ModalExportComponent.vue";
import TabDeliveryOwnerComponent
  from "@/pages/invoice/delivery-data/list-exchange-delivery/tab-exchange/tab-delivery-owner/TabDeliveryOwnerComponent.vue";
import TabDeliveryPartnerComponent
  from "@/pages/invoice/delivery-data/list-exchange-delivery/tab-exchange/tab-delivery-partner/TabDeliveryPartnerComponent.vue";
import IconArrowDown from "@/components/icons/IconArrowDown.vue";
import IconArrowUp from "@/components/icons/IconArrowUp.vue";
import ErrorMessageService from "@/services/error-message.service.js";
import router from "@/router/index.js";

export default {
  name: 'PartnerListComponent',
  components: {
    IconArrowUp, IconArrowDown,
    TabDeliveryPartnerComponent, TabDeliveryOwnerComponent,
    ModalExportComponent,
    ModalProductExportComponent, ModalProductImportComponent, LoadingComponent,
    SelectCustom,
    InputCheckboxOne,
    PaginateComponent,
    ButtonAddComponent,
    IconTrash,
    IconEdit,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome},
  setup() {
    const dataHeaderTable =  ref({
      partner_name: {
        label: 'Tên công ty',
        order: 2,
        width: '20%',
        sort: 1
      },
      partner_code: {
        label: 'Mã công ty',
        order: 3,
        width: '8%',
        sort: 1
      },
      companyEmail: {
        label: 'Email',
        order: 4,
        width: '10%',
      },
      companyPhone: {
        label: 'Số điện thoại',
        order: 5,
        width: '10%',
      },
      companyPriority: {
        label: 'Cấp độ',
        order: 5,
        width: '10%',
      },
      companyStatus: {
        label: 'Trạng Thái',
        order: 6,
        width: '10%',
      },
    })
    const dataHeaderInviteTable = ref({
      companyName: {
        label: 'Tên công ty',
        order: 2,
        width: '20%',
      },
      companyCode: {
        label: 'Mã công ty',
        order: 3,
        width: '15%',
      },
      companyEmail: {
        label: 'Email',
        order: 4,
        width: '20%',
      },
      companyPhone: {
        label: 'Số điện thoại',
        order: 5,
        width: '20%',
      },
      companyInviteDate: {
        label: 'Ngày mời hợp tác',
        order: 6,
        width: '30%',
      }
    })
    const location = ref('Đối tác')
    const table = ref('partner')
    const labelButtonSearch = ref('Tìm kiếm')
    const labelButtonInvite = ref('Mời đối tác')
    const urlOrigin = ref('/partner/list/')
    const labelButtonImport = ref('Nhập file đối tác')
    const dataSearch = ref({
      name_partner: {
        id: 'name',
        label: 'Tên công ty',
        placeholder: 'Tên công ty',
        value: ''
      },
      code_partner: {
        id: 'code',
        label: 'Mã công ty',
        placeholder: 'Mã công ty',
        value: ''
      },
      email_partner: {
        id: 'email',
        label: 'Email công ty',
        placeholder: 'Email công ty',
        value: ''
      },
      phone_partner: {
        id: 'phone',
        label: 'Số điện thoại',
        placeholder: 'Số điện thoại',
        value: ''
      },
      priority_partner: {
        id: 'priority',
        label: 'Mức độ ưu tiên',
        placeholder: 'Mức độ ưu tiên',
        value: '',
        options: [
          {
            name: 'Cơ bản',
            value: '1'
          },
          {
            name: 'Cần thiết',
            value: '2'
          },
          {
            name: 'Quan tâm',
            value: '3'
          },
          {
            name: 'Quan trọng',
            value: '4'
          },
          {
            name: 'VIP',
            value: '5'
          }
        ]
      },
      status_partner: {
        id: 'status',
        label: 'Trạng thái liên kết',
        placeholder: 'Trạng thái liên kết',
        value: '',
        options: [
          {
            name: 'Chưa kết nối',
            value: 0
          },
          {
            name: 'Đã mời',
            value: 1
          },
          {
            name: 'Từ chối kết nối',
            value: 2
          },
          {
            name: 'Đã kết nối',
            value: 3
          }
        ]
      }
    })
    const checkAll = ref(false)
    const errorMessage = ref([])
    const checkItems = ref({})
    const selectAction = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_PARTNER))
    const selectActionInvite = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_INVITE_CONNECT))
    const selectLimitPage = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_PAGE))
    const eventClickShowModalImport = ref(false)
    const isLoading = ref(false)
    const eventClickShowModalExport = ref(false)
    const listItemSelected = ref([])
    const tabSelected = ref(AppConstant.TAB_OWNER)
    const partnerStore = usePartnerStore()
    const accountStore = useAccountStore()
    const router = useRouter()
    const stateModal = reactive({
      modalExportFile: null,
      modalImportFile: null,
    })
    onMounted(() => {
      stateModal.modalExportFile = new bootstrap.Modal('#modalExport', {})
      getListPartner(router.currentRoute.value.query.page ?? 1);
    });

    const listPartners = computed(() => {
      return partnerStore.partners;
    });

    const listInvites = computed(() => {
      return partnerStore.invitePartner;
    });
    const paginate = computed(() => {
      return partnerStore.paginate;
    });

    function emitPage(page) {
      getListPartner(page);
    }
    function redirectToInvite() {
      router.push('/partner/invite')
    }

    async function getListPartner(page, take = 10 ) {
      const params = {
        id: accountStore.account.company.id,
        name_partner: dataSearch.value.name_partner.value,
        code_partner: dataSearch.value.code_partner.value,
        email_partner: dataSearch.value.email_partner.value,
        phone_partner: dataSearch.value.phone_partner.value,
        priority_partner: dataSearch.value.priority_partner.value,
        status_partner: dataSearch.value.status_partner.value,
        sort: listKeySort.value,
        page: page,
        take: take,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/partner/partner-list-limit';
      await partnerStore.getListPartnerWithLimit(url, params);
    }

    watch(() => partnerStore.partners, (newListPartner) => {
      checkItems.value = {}
      newListPartner.forEach((partner) => {
        if(checkItems.value[partner.id] === undefined) {
          checkItems.value[partner.id] = false
        }
      })
    });

    watch(() => partnerStore.invitePartner, (newListInvite) => {
      checkItems.value = {}
      newListInvite.forEach((partner) => {
        if(checkItems.value[partner.id] === undefined) {
          checkItems.value[partner.id] = false
        }
      })
    });

    function onChangeSelectAll(value) {
      checkAll.value = value
      for (const key in checkItems.value) {
        checkItems.value[key] = value
      }
      if(!value) {
        listItemSelected.value = []
      }else {
        const listItem = tabSelected.value === AppConstant.TAB_OWNER ? listPartners.value : listInvites.value;
        listItem.forEach((item) => {
          if(listItemSelected.value.indexOf(item.id) === -1) {
            listItemSelected.value.push(item.id)
          }
        })
      }
    }

    function onChangeSelectItem(value, name) {
      checkItems.value[name] = value
      let counterChecked = 0
      listPartners.value.forEach((product) => {
        if(checkItems.value[product.id]) {
          counterChecked++
        }
        if(value && listItemSelected.value.indexOf(product.id) === -1 && parseInt(name) === parseInt(product.id)) {
          listItemSelected.value.push(product.id)
        }else if (!value && listItemSelected.value[product.id]) {
          listItemSelected.value.splice(listItemSelected.value.indexOf(product.id), 1);
        }
      })
      checkAll.value = false
      if(counterChecked === listPartners.value.length) {
        checkAll.value = true
      }
    }

    function actionSelect(key) {
      if(listItemSelected.value.length === 0) {
        CommonService.showAlertPopup({
          title: 'Vui lòng chọn dữ liệu để thực hiện!',
          icon: "warning",
          showConfirmButton: false,
          timer: 1500,
          width: '800px'
        });
      }else {
        switch (parseInt(key)) {
          case AppConstant.ACTION_TYPE_DELETE:
            deletePartner();
            break;
          case AppConstant.ACTION_TYPE_EXPORT_EXCEL:
            exportExcel();
            break;
          case AppConstant.ACTION_TYPE_ACCEPT:
            acceptInvite();
            break;
        }
      }
    }

    async function deletePartner() {
      const params = {
        company_id: accountStore.account.company.id,
        partner_ids: listItemSelected.value,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/partner/delete';
      const res = await CommonService.__delete(params, url, partnerStore);
      const errorMessageRes = await ErrorMessageService.getErrorMessage(res)
      if(errorMessageRes !== undefined && errorMessageRes.length > 0) {
        errorMessage.value = typeof errorMessageRes === 'string' ? [errorMessageRes] : errorMessageRes;
      } else {
        await CommonService.showAlertPopup({
          title: res?.message,
          icon: res?.status,
          showConfirmButton: false,
          timer: 1200,
          width: '800px'
        });
        if(res?.status === 'success') {
          partnerStore.partners = partnerStore.partners.filter(item => !listItemSelected.value.includes(item.id))
          partnerStore.paginate.itemCount -= listItemSelected.value.length
        }
      }
    }

    async function acceptInvite() {
      const params = {
        company_zip: accountStore.account.company.company_zip,
        company_id: accountStore.account.company.id,
        invite_ids: listItemSelected.value,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/partner/accept';
      const res = await partnerStore.acceptInvite(url, params);
      await this.showAlertPopup({
        title: res?.message,
        icon: res?.status,
        showConfirmButton: false,
        timer: 1200,
        width: '800px'
      });
      await getListPartner(router.currentRoute.value.query.page ?? 1);
    }

    async function actionLimitPage(key) {
      let limitPage = AppConstant.LIMIT_PAGE_10
      switch (parseInt(key)) {
        case AppConstant.LIMIT_PAGE_10:
          limitPage = AppConstant.LIMIT_PAGE_10;
          break;
        case AppConstant.LIMIT_PAGE_20:
          limitPage = AppConstant.LIMIT_PAGE_20;
          break;
        case AppConstant.LIMIT_PAGE_50:
          limitPage = AppConstant.LIMIT_PAGE_50;
          break;
      }
      getListPartner(1, limitPage);
    }
    function eventShowModalExport(isShow) {
      if(isShow) {
        setTimeout(function () {
          eventClickShowModalExport.value = false
          isLoading.value = false
          stateModal.modalExportFile.show()
        }, 1000);
        return;
      }
      checkAll.value = false
      listPartners.value.forEach((item) => {
        checkItems.value[item.id] = false
      })
      listItemSelected.value = []
      stateModal.modalExportFile.hide()
    }
    function showErrorMessage(mess) {
      errorMessage.value = [mess]
    }
    function removeError(key) {
      errorMessage.value.splice(key, 1)
    }
    async function exportExcel() {
      settingExportFields()
    }
    function settingExportFields() {
      showModalExport()
    }
    function showModalExport () {
      eventClickShowModalExport.value = true
      isLoading.value = true
    }

    const listKeySort = computed(() =>
      Object.entries(dataHeaderTable.value)
        .filter(([_, v]) => v.sort !== undefined)
        .map(([key, v]) => ({ key, sort: v.sort }))
    )
    function sortPartners(key) {
      dataHeaderTable.value[key].sort = dataHeaderTable.value[key].sort === 1 ? -1 : 1
      getListPartner(1)
    }

    function searchPartners() {
      getListPartner(1);
    }

    return {
      listPartners,
      listInvites,
      dataHeaderTable,
      dataHeaderInviteTable,
      labelButtonSearch,
      labelButtonInvite,
      dataSearch,
      paginate,
      urlOrigin,
      checkAll,
      checkItems,
      selectAction,
      selectActionInvite,
      selectLimitPage,
      labelButtonImport,
      eventClickShowModalImport,
      isLoading,
      eventClickShowModalExport,
      listItemSelected,
      errorMessage,
      location,
      table,
      emitPage,
      redirectToInvite,
      onChangeSelectAll,
      onChangeSelectItem,
      actionSelect,
      actionLimitPage,
      eventShowModalExport,
      showErrorMessage,
      removeError,
      sortPartners,
      searchPartners,
      CommonService,
      CommonText
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .btn-invite-partner {
          width: 150px;
          margin-top: 50px;
        }
        .list-partners-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
          table {
            display: block;
            overflow-x: auto;
            white-space: nowrap;
            td {
              max-width: 100%;
            }
          }
        }

      }
    }
  }
}
@media (max-width: 1024px) {
  .search-partner-component {
    .search-box {
      flex-direction: column;
      .list-search {
        flex-direction: column !important;
        align-items: flex-start;
      }
      .btn-action {
        margin-top: 12px;
      }
    }
  }
}
</style>
